(() => {
  if (window.drboHerbstValueInitialized) return;
  window.drboHerbstValueInitialized = true;
  const refresh = () => {
    document.querySelectorAll('[data-herbst-pricing], [data-herbst-active][data-herbst-end]').forEach((region) => {
      const deadline = Date.parse(region.dataset.herbstEnd);
      if (!Number.isFinite(deadline) || Date.now() >= deadline) {
        if (region.hasAttribute('data-herbst-active')) region.hidden = true;
        region.querySelectorAll('[data-herbst-active]').forEach((element) => { element.hidden = true; });
      }
    });
  };
  refresh();
  window.setInterval(refresh, 30000);
  document.addEventListener('visibilitychange', refresh);
  document.addEventListener('shopify:section:load', refresh);
})();
